import * as React from 'react';
import { IMoveableSurfaceProps, IUpdateHandler } from './moveable-types';
import { MoveableSurfaceSizeProvider } from './moveable-context';

export class MoveableSurface<T = {}> extends React.PureComponent<IMoveableSurfaceProps<T>> {
    private containerRef: React.RefObject<HTMLElement> = React.createRef();
    private updateHandlers: Set<IUpdateHandler> = new Set();

    constructor(props: IMoveableSurfaceProps<T>) {
        super(props);
        const { context } = this.props;
        if (context?.containerRef !== undefined) {
            this.containerRef = context.containerRef;
        }
    }

    render() {
        const { children, context } = this.props;

        return (
            <MoveableSurfaceSizeProvider value={{
                containerRef: this.containerRef,
                ...context,
                addUpdateListener: this._addUpdateListener,
                removeUpdateListener: this._removeUpdateListener,
                updateMoveables: this._updateMoveables
            }}>
                {children(this.containerRef)}
            </MoveableSurfaceSizeProvider>
        );
    }

    private _addUpdateListener = (handler: IUpdateHandler) => {
        this.updateHandlers.add(handler);
    }

    private _removeUpdateListener = (handler: IUpdateHandler) => this.updateHandlers.delete(handler)

    private _updateMoveables = () => {
        this.updateHandlers.forEach((handler) => handler());
    }
}
